
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'

import global from '../../../static/js/global'
export default {
components: {XTextarea,Group,XHeader,XSwitch,XButton },
data () {
return {
theme:'',
imgList: [],
max:4,
open:false,
loadmore:false,
maxheight:window.screen.height
}
},
beforeMount(){
if(this.$router.history.current.path == "/momentspublush"){
document.title = "邻里分享";
}
this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
},
methods: {
deleteImg(index){
this.imgList.splice(index,1)
},
submitTheme(){
if(!this.theme){
AlertModule.show({
title: '温馨提示',
content: '请输入你要发表的内容',
})
}else{
this.loadmore = true;
let data = {comnCode:this.$router.history.current.query.communityId,mainPhone:this.$router.history.current.query.phone,themeDesc:this.theme,visibleRange:this.open?'1':'0',origiImg:this.imgList};
this.$http.post(global.host + 'themeShare/releaseTheme',data,{header:{Accept: "application/json; charset=utf-8"}}).then(function(res){
if(res.body.statusCode == '110'){
this.$router.push({path:'/momentslist',query:{communityId:this.$router.history.current.query.communityId,openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,comnCode:this.$router.history.current.query.comnCode,comnCodes:this.$router.history.current.query.comnCodes}});
}else{
AlertModule.show({
title: '温馨提示',
content: '发布邻里话题失败',
})
this.loadmore = false;
}
},function(err){
AlertModule.show({
title: '温馨提示',
content: '发布邻里话题失败',
})
this.loadmore = false;
})
}
},
fileChange(el) {
let files = document.getElementById('upload_file').files;
if(this.max-this.imgList.length == 0){
return;
}
let size = files.length > this.max-this.imgList.length  ? this.max-this.imgList.length : files.length;
for (let i = 0; i < size; i++) {
if (files[i].type.indexOf('image') == -1) {
alert('请选择图片文件');
} else {
let reader = new FileReader();
let _this = this;
reader.readAsDataURL(files[i]);
reader.onload = function (event) {
var img = new Image;

let width = 680, //图像大小
quality = 0.9, //图像质量
canvas = document.createElement("canvas"),
drawer = canvas.getContext("2d");
img.src = event.target.result;
img.onload = function () {
canvas.width = width;
canvas.height = width * (img.height / img.width);
drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
let imgBase64 = canvas.toDataURL("image/jpeg", quality);
_this.imgList.push(imgBase64);
img.src="";
}

}

}
}

}
}
}



// WEBPACK FOOTER //
// ./src/components/momentsComponents/publish.vue